export default __webpack_public_path__ + "static/media/123.eb417040.png";